// TODO: we need to get these types from some backend source for access-ws that
// I'm not sure currently exists yet
import type {
    FirmWithParentsAndChildren,
    FirmInvitation,
    FirmMembershipWithProfile,
    UpdateFirm,
} from '@thinkalpha/ui-types/types/admin/firms';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';
import type { UpdateFirmMemberRoles } from 'src/lib/user/types';

const accessApi = createInstance({ baseURL: appConfig.accessApi });

export const getFirm = async (firmId: string) => {
    const { data } = await accessApi.get<FirmWithParentsAndChildren>(`/firms/${firmId}`);
    return data;
};

export const getFirms = async () => {
    const { data } = await accessApi.get<FirmWithParentsAndChildren[]>(`/firms`);
    return data;
};

export const getUserFirms = async (userId: string) => {
    const { data } = await accessApi.get<FirmWithParentsAndChildren[]>(`/firms`, { params: { userId } });
    return data;
};

export const getFirmMembers = async (firmId: string) => {
    const { data } = await accessApi.get<FirmMembershipWithProfile[]>(`/firms/${firmId}/members`);
    return data;
};

export const getFirmInvitees = async (firmId: string) => {
    const { data } = await accessApi.get<FirmInvitation[]>(`/firms/${firmId}/invitations`);
    return data;
};

export const updateFirm = async ({ firmId, firmUpdates }: UpdateFirm): Promise<FirmWithParentsAndChildren> => {
    const { data } = await accessApi.patch<FirmWithParentsAndChildren>(`/firms/${firmId}`, firmUpdates);
    return data;
};

export const getFirmMemberRoles = async (firmId: string, firmMemberId: string): Promise<Array<string>> => {
    const { data } = await accessApi.get<Array<string>>(`/firms/${firmMemberId}/firm-memberships/${firmId}/roles`);
    return data;
};

export const updateFirmMemberRoles = async ({
    firmId,
    firmMemberId,
    roles,
}: UpdateFirmMemberRoles): Promise<FirmMembershipWithProfile> => {
    const { data } = await accessApi.patch<FirmMembershipWithProfile>(`/firms/${firmId}/members/${firmMemberId}`, {
        roles,
    });
    return data;
};
